<template>
  <gkModal v-model="visible" :maskClickClose="false" class="modal-guide" @close="handleClose">
    <div class="login-head">
      <h1 class="login-type">{{modalTitle}}</h1>
      <p class="head-sub" v-for="(title, index) in subTitle" :key="index">{{title}}</p>
    </div>

    <div class="modal-content" v-if="step == 1">
      <div class="loading-pannel" v-if="loading">
        <gkLoading color="blue" loading />
      </div>
      <div class="topic-list" v-else>
        <div class="topic-item"
          :class="[{selected: item.selected}]"
          v-for="(item, index) in list" :key="index"
          @click="handleSelect(item)"
        >
          <span class="topic-name">{{item.name}}</span>
        </div>
      </div>
    </div>
    <div class="modal-content" v-if="step == 2">
      <div class="loading-pannel" v-if="loading">
        <gkLoading color="blue" loading />
      </div>
      <div class="container">
        <div class="tab-list" ref="tabList">
          <div
            :class="['radio', {on: cur == topic.id}]"
            v-for="(topic, index) in selected"
            :key="index"
            @click="handleChoice(topic)"
          >
            {{topic.name}}
          </div>
        </div>
        <div class="columns-list" :style="{height: scrollMaxHeight + 'px'}">
        <gkScrollBar class="scroll-bar" ref="scrollBar">
          <div class="column-item" v-for="column in filterColumns" :key="column.id">
            <div class="column-cover">
              <img :src="column.cover" alt="" />
            </div>
            <div class="info">
              <h6 class="title" @click="jumpColumn(column)">{{column.title}}</h6>
              <p class="author-detail" v-if="column.author || column.intro">
                <span class="label author" v-if="column.author">{{column.author}}</span>
                <span class="label intro" v-if="column.intro">{{column.intro}}</span>
              </p>
              <p class="column-detail" v-if="column.sub">
                <span class="length">{{column.unit || '全年'}}</span>
                <span class="length">| {{column.sub}} 人已学习</span>
              </p>
              <div class="bottom">
                <p class="price">
                  <i class="iconfont">&#xe66d;</i>
                  {{column.price | columnPriceToFix}}
                </p>
                <gkButton color="orange" size="height27" @click="receive(column.sku)">免费领取</gkButton>
              </div>
            </div>
          </div>
        </gkScrollBar>
        </div>
      </div>
    </div>

    <div class="footer" :class="[{'select-column': step == 2}]" slot="footer">
      <template v-if="step == 1">
        <gkButton color="white" size="default" @click="skip">跳过</gkButton>
        <gkButton class="next-btn" color="blue" size="default" :disabled="nextBtnDisabled" useLock @click="handleSub">下一步</gkButton>
      </template>
    </div>
  </gkModal>
</template>

<script>
import VueTypes from 'vue-types'
import gkButton from 'gkui/button'
import gkModal from 'gkuiV2/modal'
import gkLoading from 'gkui/loading'
import gkScrollBar from 'gkui/scrollbar/Scrollbar'

import TopicService from '../../../service/topic.service'
import ActivityService from '../../../service/activity.service'
import AccountService from '../../../service/account.service'

import config from '../../../config'
import utils from '../../../utils'
import sensorsReport from '../../../utils/sensors.report'

// 活动专栏和频道的对应关系
const relationMap = {
  // 6: 1,
  // 8: 1,
  // 11: 5,
  // 13: 2,
  // 15: 4,
  // 31: 4,
  // 32: 3,
  // 33: 2,
  // 38: 5,
  // 43: 6,
  // 81: 1,
  // 1137: 7
  81: 1,
  13: 2,
  32: 3,
  15: 4,
  11: 5,
  43: 6,
  1137: 7,
  31: 8,
  38: 9,
  33: 10,
  6: 11,
  8: 11
}

/**
 * 编程语言 32
 * 云计算  11
  运维  38
  架构  8
  移动 13
  大数据 15
  前端 33
  Java 6
  区块链  81
  AI 31
  技术管理 43
  产品 1137
 */
const topicIds = [8, 33, 32, 31, 11, 81, 43, 38, 1137, 6, 15, 13]

export default {
  name: 'modal-login',
  components: {
    gkModal,
    gkButton,
    gkLoading,
    gkScrollBar
  },
  props: {
    theme: VueTypes.oneOf(['blue', 'green']).def('blue')
  },
  data () {
    return {
      loading: false,
      list: [],
      selected: [],
      visible: false,
      step: 1, // 新用户引导进度  1 选择兴趣领域  2 领取课程
      cur: 0,
      columns: [],
      filterColumns: [],
      scrollMaxHeight: 0,
      onSuccess: null,
      onError: null
    }
  },
  computed: {
    modalTitle () {
      return this.step === 1 ? '选择你的兴趣领域' : '领取免费课程'
    },
    subTitle () {
      return this.step === 1 ? ['注册成功！', '选择兴趣领域，InfoQ 会为你更好地推荐内容，还可领取 InfoQ 为你准备的免费课程。'] : ['根据你的兴趣领域，我们为你准备了一些课程，可在下方选择一套并领取免费 7 天学习权益。']
    },
    nextBtnDisabled () {
      return !this.list.some(item => item.selected === true)
    }
  },
  watch: {
    step () {
      this.$nextTick(() => {
        let $tabList = this.$refs.tabList

        if ($tabList) {
          this.scrollMaxHeight = 382 - $tabList.clientHeight
        }
      })
    }
  },
  created () {
  },
  mounted () {
    this.getRecommendList()
  },
  methods: {
    show ({success, error}) {
      this.visible = true
      this.onSuccess = success
      this.onError = error

      sensorsReport.pushEvent('dialog_infoq_interest')
    },
    hide () {
      this.visible = false
      this.onSuccess = null
      this.onError = null
    },
    loginSuccess () {
      this.onSuccess && this.onSuccess().then(() => {
        this.hide()
      }).catch(() => {
      })
    },
    next () {
      this.step = 2
      sensorsReport.pushEvent('dialog_infoq_signupgifts')
    },
    skip () {
      this.giveUpReceive()
      this.hide()
    },
    handleClose () {
      // 关闭窗口中断领取权益流程
      this.giveUpReceive()
    },
    /**
     * 放弃领取新人专栏权益
     */
    giveUpReceive () {
      AccountService.addReceiveModalStatus()
    },
    /**
     * 下一步 批量关注
     */
    handleSub ({clear}) {
      this.selected = this.list.filter(item => item.selected)

      let ids = this.selected.map(topic => topic.id)

      TopicService.batchSub(ids).then(res => {
        this.next()
        this.loading = true
        this.cur = this.selected[0].id

        ActivityService.getActivityColumn().then(res => {
          this.columns = res
          this.filterColumns = res[relationMap[this.cur]]
          this.loading = false
        })
        clear && clear()
      }).catch(() => {
        clear && clear()
      })
    },
    getRecommendList () {
      this.loading = true

      TopicService.getTopicByIds(topicIds).then(res => {
        this.loading = false
        this.list = res.map((item, index) => {
          item.selected = false
          return item
        }).slice(0, 12)
      })
    },
    handleSelect (topic) {
      topic.selected = !topic.selected
    },
    handleChoice (topic) {
      this.cur = topic.id
      this.filterColumns = this.columns[relationMap[topic.id]]
    },
    jumpColumn (column) {
      // https://time.geekbang.org/column/intro/%d
      let path = `${config.timeHost}/column/intro/${column.sku}`
      utils.jumpUrl(path)
    },
    receive (sku) {
      this.$gkConfirm.create({
        title: '确认领取此课程？',
        content: '新用户福利只能领取一次，领取后即生效',
        cancelBtnLabel: '重新选择'
      }, {
        ok: ({close}) => {
          AccountService.getNewAccountGift(sku).then(res => {
            this.loginSuccess()
            this.$emit('receiveSuccess')
            this.giveUpReceive()
            close && close()
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/_common";

.modal-guide[gkmodal-color="base"] {
  & ::v-deep [gk-modal-main] {
    box-sizing: border-box;
    width: 442px; min-height: 558px;
    padding: 32px 49px 26px;

    @include mobile () {
      top: 0;
      width: 310px; min-height: auto;
      padding: 34px 24px 23px;
    }
  }
}

.login-head {
  height: 88px;
  margin: 25px 0 15px;

  @include mobile () {
    height: 83px;
    margin: 0;
  }
}

.login-type {
  margin-bottom: 4px;
  line-height: 28px;
  @include font(28, 500);
  color: $lightBlack;

  @include mobile () {
    font-size: 20px;
  }
}

.head-sub {
  line-height: 21px;
  @include font(14, 400);
  color: $gray;

  & a {
    color: $blue;
  }

  @include mobile () {
    // word-break: keep-all;
    margin-right: -2px;
    line-height: 18px;
    font-size: 12px;
  }
}

.modal-content {
  display: flex;
}

.loading-pannel {
  width: 100%; height: 290px;
  @extend %center;
}

.topic-list {
  display: flex;
  flex-wrap: wrap;
  margin-top: 47px;

  @include mobile () {
    margin-top: 41px;
  }

  & .topic-item {
    box-sizing: border-box;
    position: relative;
    @extend %center;
    width: 104px; height: 36px;
    margin-right: 16px; margin-bottom: 16px;
    border: 1px solid $borderGray;
    border-radius: 4px;
    @include font(16, 400);
    color: $lightBlack;
    cursor: pointer;
    user-select: none;

    &:nth-child(3n) {
      margin-right: 0;
    }

    & .topic-name {
      width: 100%;
      @extend %row;
      text-align: center;
    }

    &.selected {
      background: #F8F9FA;

      &:before {
        content: '';
        position: absolute; top: -5px; right: -4px;
        width: 16px; height: 16px;
        background: url('../../../assets/img/icon/success.png') no-repeat;
        background-size: cover;
        border-radius: 50%;
      }
    }

    @include mobile () {
      width: 78px; height: 32px;
      padding: 0 4px; margin: 0 14px 14px 0;
      font-size: 14px;
    }
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-top: 73px;
  color: $gray;

  &.select-column {
    margin-top: 0;
  }

  @include mobile () {
    margin-top: 46px;
  }
}

.next-btn {
  width: 143px;
  margin-left: 7px;

  @include mobile () {
    width: 125px;
    margin-left: 0;
  }
}

.container {
  & .tab-list {
    display: flex;
    flex-wrap: wrap;
  }

  & .radio {
    background: #F8F9FA;
    padding: 5px 10px; margin: 0 10px 10px 0;
    border-radius: 4px;
    line-height: 1;
    @include font(16, 400);
    color: $gray;
    cursor: pointer;
    user-select: none;

    &.on {
      background: #F2F6FF;
      font-weight: 500;
      color: $blue;
    }

    @include mobile () {
      font-size: 14px;
    }
  }
}

.columns-list {
  margin-top: 14px;
  overflow-y: auto;

  & .scroll-bar ::v-deep [gk-scrollbar-inner] {
    padding-right: 10px;
  }
}

.column-item {
  display: flex;
  justify-content: space-between;
  max-width: 345px;
  margin-bottom: 15px;
  overflow: hidden;

  @include mobile () {
    max-width: 261px;
  }
}

.column-cover {
  flex-shrink: 0;
  width: 82px; height: 108px;
  margin-right: 16px;
  border-radius: 4px;

  @include mobile () {
    margin-right: 10px;
  }

  & img {
    width: 100%; height: 100%;
    border-radius: 4px;
    object-fit: cover;
    object-position: center;
  }
}

.info {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding-right: 4px;

  & .title {
    width: 240px;
    margin-bottom: 5px;
    @extend %row;
    line-height: 27px;
    @include font(18, 500);
    color: #4c4c4c;
    cursor: pointer;

    @include mobile () {
      width: 170px;
      margin-bottom: 2px;
      line-height: 25px;
      font-size: 16px;
    }
  }

  & .author-detail {
    display: flex;
    display: inline-block;
    height: 17px;

    @include mobile () {
      width: 170px;
    }
  }

  & .column-detail {
    margin-top: 7px;
    @include lineFont(12, 400);
    color: #9e9e9e;
  }

  & .label {
    display: inline-block;
    box-sizing: border-box;
    height: 17px;
    padding: 1px 3px; margin-right: 7px;
    background: #f1f1f1;
    border-radius: 2px;
    @extend %row;
    @include lineFont(13, 400);
    line-height: 17px;
    color: #767676;

    &.author {
      max-width: 70px;
      @include mobile () {
        max-width: 60px;
      }
    }

    &.intro {
      max-width: 140px;

      @include mobile () {
        max-width: 90px;
      }
    }
  }

  & .bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 12px;

    @include mobile () {
      margin-top: 17px;
    }

    & .price {
      position: relative; top: 2px;
      color: #FA8919;
      @include lineFont(16, 500);

      & .iconfont {
        margin-right: -4px;
      }

      @include mobile () {
        font-size: 14px;

        & .iconfont {
          font-size: 13px;
        }
      }

      &:before {
        position: relative; top: -1px;
        content: '原价:';
        vertical-align: middle;
        line-height: 16px;
        @include lineFont(12, 400);
        color: #4c4c4c;
      }
    }

    & [gk-button] {
      width: 86px; height: 27px; min-width: 86px;
      padding: 0;
      font-size: 15px;

      @include mobile () {
        position: relative; left: -4px;
        width: 80px; height: 24px; min-width: 80px;
        font-size: 14px;
      }
    }
  }
}

</style>
